import RsaGestioneCentroDiurnoListPage from "./pages/RsaGestioneCentroDiurnoListPage.vue";

export default { RsaGestioneCentroDiurnoListPage };
